import { IconButton } from '@mui/material';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import { useState } from 'react';
import { EditColourPaletteModal } from './EditColourPaletteModal';

export const EditColourPalette = ({ colourPalette, setColourPalette }) => {
    const [openEditModal, setOpenEditModal] = useState(false);

    return (
        <>
            <IconButton onClick={() => setOpenEditModal(true)} sx={{ justifySelf: 'end', alignSelf: 'center' }}>
                <EditRoundedIcon />
            </IconButton>

            {openEditModal && (
                <EditColourPaletteModal
                    isOpen={openEditModal}
                    setIsOpen={setOpenEditModal}
                    colourPalette={colourPalette}
                    setColourPalette={setColourPalette}
                />
            )}
        </>
    );
};
